/**
 * Collection SEO Content - Category Description & FAQ JavaScript
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initReadMore();
    initFAQ();
  }

  /**
   * Initialize Read More functionality for category description
   */
  function initReadMore() {
    const wrapper = document.querySelector('.category-long-description__wrapper');
    const btn = document.querySelector('.category-long-description__btn');
    const btnTextExpand = document.querySelector('.category-long-description__btn-text--expand');
    const btnTextCollapse = document.querySelector('.category-long-description__btn-text--collapse');

    if (!wrapper || !btn) return;

    // Check if content exceeds the max-height
    const content = wrapper.querySelector('.category-long-description__content');
    if (!content) return;

    // Store original max-height from CSS
    const computedStyle = window.getComputedStyle(wrapper);
    const originalMaxHeight = parseInt(computedStyle.maxHeight) || 400;
    const contentHeight = content.scrollHeight;

    // Hide button if content doesn't overflow
    if (contentHeight <= originalMaxHeight) {
      const toggleContainer = document.querySelector('.category-long-description__toggle');
      if (toggleContainer) {
        toggleContainer.style.display = 'none';
      }
      wrapper.classList.add('is-expanded');
      wrapper.style.maxHeight = 'none';
      return;
    }

    // Set initial max-height explicitly for proper transitions
    wrapper.style.maxHeight = originalMaxHeight + 'px';

    btn.addEventListener('click', function() {
      const isExpanded = wrapper.classList.contains('is-expanded');

      if (isExpanded) {
        // Collapse - first set to current height, then animate to original
        wrapper.style.maxHeight = content.scrollHeight + 'px';

        // Force reflow
        wrapper.offsetHeight;

        // Now animate to collapsed state
        wrapper.style.maxHeight = originalMaxHeight + 'px';
        wrapper.classList.remove('is-expanded');
        btn.classList.remove('is-expanded');

        if (btnTextExpand) btnTextExpand.style.display = '';
        if (btnTextCollapse) btnTextCollapse.style.display = 'none';

        // Smooth scroll to top of description after a short delay
        setTimeout(function() {
          const descriptionSection = document.querySelector('.category-long-description');
          if (descriptionSection) {
            const headerOffset = 120;
            const elementPosition = descriptionSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            if (elementPosition < 0) {
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          }
        }, 100);
      } else {
        // Expand
        wrapper.classList.add('is-expanded');
        btn.classList.add('is-expanded');
        wrapper.style.maxHeight = content.scrollHeight + 'px';

        if (btnTextExpand) btnTextExpand.style.display = 'none';
        if (btnTextCollapse) btnTextCollapse.style.display = '';

        // After transition completes, set to none for dynamic content
        setTimeout(function() {
          if (wrapper.classList.contains('is-expanded')) {
            wrapper.style.maxHeight = 'none';
          }
        }, 600);
      }
    });
  }

  /**
   * Initialize FAQ accordion functionality
   */
  function initFAQ() {
    const faqItems = document.querySelectorAll('.collection-faq__item');

    if (!faqItems.length) return;

    faqItems.forEach(function(item) {
      const question = item.querySelector('.collection-faq__question');
      const answer = item.querySelector('.collection-faq__answer');
      const answerContent = item.querySelector('.collection-faq__answer-content');

      if (!question || !answer || !answerContent) return;

      question.addEventListener('click', function() {
        const isActive = item.classList.contains('is-active');

        // Close all other items (accordion behavior)
        faqItems.forEach(function(otherItem) {
          if (otherItem !== item && otherItem.classList.contains('is-active')) {
            closeFAQItem(otherItem);
          }
        });

        // Toggle current item
        if (isActive) {
          closeFAQItem(item);
        } else {
          openFAQItem(item);
        }
      });

      // Keyboard accessibility
      question.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          question.click();
        }
      });
    });
  }

  /**
   * Open FAQ item with animation
   */
  function openFAQItem(item) {
    const answer = item.querySelector('.collection-faq__answer');
    const answerContent = item.querySelector('.collection-faq__answer-content');
    const question = item.querySelector('.collection-faq__question');

    if (!answer || !answerContent) return;

    item.classList.add('is-active');
    if (question) question.setAttribute('aria-expanded', 'true');

    // Get the natural height of the content
    const contentHeight = answerContent.scrollHeight;
    answer.style.maxHeight = contentHeight + 'px';
  }

  /**
   * Close FAQ item with animation
   */
  function closeFAQItem(item) {
    const answer = item.querySelector('.collection-faq__answer');
    const question = item.querySelector('.collection-faq__question');

    if (!answer) return;

    item.classList.remove('is-active');
    if (question) question.setAttribute('aria-expanded', 'false');
    answer.style.maxHeight = '0';
  }

  // Re-initialize on Shopify section reload (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.collection-seo-content')) {
      init();
    }
  });

})();
